module.exports = __webpack_public_path__ + "static/team-main-image-557ddc9b549359c3d7e600fe28801007.jpg";